import React from "react";
import clsx from "clsx";

import common from "../common.module.scss";

import styles from "./HelpMaintenance.module.scss";

const HelpMaintenance = () => {
  return (
    <div className={styles.maintenance}>
      <div className={clsx(common.content, styles.content)}>
        <div className={styles.block}>
          <p className={styles.heading}>定期メンテナンスについて</p>
          <p className={styles.text}>
            隔週水曜日 22:00 〜 23:30 の時間帯で定期メンテナンスを行います。
            <br />
            該当時間中にアクセスできなくなることがありますが、何卒ご了承ください。
          </p>
        </div>
        <div className={styles.block}>
          <p className={styles.heading}>商標について</p>
          <p className={styles.text}>
            本文中に記載されている会社名、製品名等は、各社の登録商標または商標です。
            <br />
            本ウェブサイトは、独立した（製作物）であり、商標登録している各社が認定、後援、その他承認したものではありません。
            <br />
            ※iPad、iPhone、Mac、Safariは米国および他の国々で登録された Apple
            Inc. の商標です。
            <br />
            ※iPhone商標は、アイホン株式会社のライセンスに基づき使用されています。
            <br />
            ※iOS商標は、米国Ciscoのライセンスに基づき使用されています。
            <br />
            ※Google、Android、Google Chrome、Chromebook は、Google LLC
            の商標です。
            <br />
            ※Windows、Microsoft Edge、Internet Explorerは、米国Microsoft
            Corporationの米国およびその他の国における登録商標です。
          </p>
        </div>
      </div>
    </div>
  );
};

export default HelpMaintenance;
